<template>
  <basic-container>
    <el-tabs v-model="tabs" type="card" >
      <el-tab-pane label="已结算" name="1"></el-tab-pane>
      <el-tab-pane label="起草中" name="0"></el-tab-pane>
    </el-tabs>
    <div v-if = "tabs === '0'">
      <div class="search_group">
        <el-date-picker v-model="searchTime" type="monthrange" value-format="yyyy-MM" size="small" ange-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"></el-date-picker>
        <el-select  @change="searchAct" v-model="status" size="small" clearable placeholder="状态">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button @click="searchAct" icon="el-icon-search" size="small" type="success">查询</el-button>
        <template v-if="isPermission">
          <el-button v-authority="'ad:settle:save'"  @click="addSummary" icon="el-icon-plus" size="small" type="primary">新增</el-button>
          <el-button v-authority="'ad:settle:update'"   @click="editSummary" icon="el-icon-edit" size="small" type="primary">修改</el-button>
          <el-button v-authority="'ad:settle:delete'"  icon="el-icon-delete" size="small" type="danger" @click="delProject">删除</el-button>
        </template>
      </div>
      <el-table :max-height="autoTableHeight"
        ref="eltable"
        v-loading="listLoading" element-loading-text="加载中" border :data="tableData"
        @selection-change="handleSelectionChange"
        >
        <el-table-column  align="center" type="selection" width="50"></el-table-column>
        <el-table-column  align="center" prop="month" label="月份" width="200"></el-table-column>
        <el-table-column  align="center"  prop="scope" label="版本" width="200">
          <template slot-scope="scope">{{ 'V' + scope.row.version }}</template>
        </el-table-column>
        <el-table-column  align="left"   prop="name" label="版本名称" width="120"></el-table-column>
        <el-table-column  align="center" label="状态">
          <template slot-scope="scope">
            <span :class="
                          scope.row.status == 5
                            ? 'red'
                            : scope.row.status == 4
                            ? 'green'
                            : scope.row.status == 3
                            ? 'blue'
                            : ''
                          ">{{scope.row.status | adProjectStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column align="right" prop="totalMoney" label="结算金额（元）" width="180"></el-table-column>
        <el-table-column align="right" prop="totalCpm" label="结算量（CPM）"></el-table-column>
        <el-table-column align="center"  fixed="right" width="100" label="操作">
          <template slot-scope="scope">
            <el-button @click="openDetails(scope.row, 1)" icon="el-icon-info" size="mini" type="text">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table_pagination">
        <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
        </el-pagination>
      </div>
    </div>
    <!-- 审核通过的项目 -->
    <div v-if = "tabs === '1'">
      <settedTable></settedTable>
    </div>
    <addSummaryDialog
      :summaryDailogFlag.sync="showAddDialog"
      :editId = "editId"
      :editType = "editType"
      :row = 'editRow'
      @submit="getList"
      ></addSummaryDialog>
    <ProjectProcedure :projectProcedurelFlag.sync="projectProcedureShow" :projectObj="rowData"></ProjectProcedure>
  </basic-container>
</template>

<script>
import { getMenuPermissions, getSettlementList, remove } from '@/api/projectSettlement/summary'
import pagination from '@/util/mixins/pagination'
import ListMixins from '@/util/mixins/listPage';
import addSummaryDialog from './components/dialogs/addSummaryDialog'
import projectProcedure from './components/projectProcedure.vue'
import projectDetail  from './components/dialogs/projectDetail.vue'
import settedTable from './components/summary/settedTable'
import ProjectProcedure from './components/projectProcedure.vue'
export default {
  mixins: [pagination, ListMixins],
  data () {
    return {
      tabs: '0',
      options: [{
        label: '起草中',
        value: 0
      },{
        label: '待审核',
        value: 3
      },{
        label: '已审核',
        value: 4
      },{
        label: '未通过',
        value: 5
      }],
      // 老乐播云数据
      oData: {
        token: this.$route.query.t,
        tid: this.$route.query.tid,
        name: this.$route.query.name
      },
      status: '',
      isPermission: false,
      userPermission: [], // 用户的权限
      userAccount: '', // 用户账户
      searchTime: '', // 时间
      selectSummary: [], // 选择的项目列表
      showDetails: false, // 详情弹窗
      showAddDialog: false, // 结算弹窗
      editId: '', // 传入编辑弹框id
      editRow: {},
      editType: '', // 传入编辑弹框类型
      rowData: {}, // 查看的详情数据
      projectProcedureShow: false, // 项目结算过程弹窗
      projectDetailShow: false // 项目结算详情弹窗
    }
  },
  components: {
    settedTable,
    addSummaryDialog,
    projectProcedure,
    projectDetail,
    ProjectProcedure
},
  mounted () {
    // 获取用户权限
    this.getMenuPermissions()
    this.getList()
  },
  methods: {
    // 获取权限
    getMenuPermissions() {
      getMenuPermissions({}, this.oData).then( res => {
        console.log(res.data, '获取用户的权限')
        if (res.data.code === 200) {
          this.userPermission = res.data.data || []
          window.localStorage.setItem('adUserAuthList', this.userPermission )
          this.isPermission = true
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch( err => {
        this.$message.error(err)
      })
    },
    addSummary () {
      this.showAddDialog = true
      this.editType = 'add'
    },
    // 查看订单明细
    checkDetail (id) {
      this.$store.dispatch('app/setOrder', id)
      this.$router.push('/member/order')
    },
    editSummary() {
      if(this.selectSummary.length === 0 ) {
        this.$message.warning('请先选择需要修改的版本')
      } else if( this.selectSummary.length === 1) {
        this.edit(this.selectSummary[0])
      } else {
        this.$message.warning('只能选择单个版本修改')
      }
    },
    edit(row) {
      this.showAddDialog = true
      this.editId = row.id
      this.editType = 'edit'
      this.editRow = Object.assign({}, row)
    },
    // 结算过程步骤的弹窗
    openDetails(row) {
      this.rowData = row
      this.projectProcedureShow = true
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        startDate: this.searchTime ? this.searchTime[0] : '',
        endDate: this.searchTime ? this.searchTime[1] : '',
        status: this.status,
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      getSettlementList(postData, this.oData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    handleSelectionChange (val) {
      this.selectSummary = val
    },
    delProject () {
      if (this.selectSummary.length === 0) {
        this.$message({
          message: '请先选择要删除的项目',
          type: 'warning'
        });
      } else {
        const ids = this.selectSummary.map(item => item.id).join(',')
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          remove(ids, this.oData).then((res)=> {
            console.log(res)
            if(res.data.code === 200 && res.data.success) this.getList()
          })
        })
      }
    },
  },
  watch: {
    tabs (val) {
      this.current = 1
      this.searchTime = ''
      if(val === '0') {
        this.getList()
      }
    },
    showAddDialog (val) {
      if(!val) {
        this.editId = ''
        this.editType = ''
        this.editRow = {}
      }
    },
    projectProcedureShow (val) {
      if(!val) {
        this.getList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.red {
  color: red;
}
.blue {
  color: blue;
}
.green {
  color: green;
}
</style>
